(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewing.controller:AssignTrainingCtrl
   *
   * @description
   *
   */
  angular
    .module('crewing')
    .controller('AssignTrainingCtrl', AssignTrainingCtrl);

  function AssignTrainingCtrl(crewScheduleService, $uibModalInstance, MessageService, CrewingHelper, modalParams, CommonMasterData, EventManagerService, PopupManager, CreatePairing, ApplicationParametersService) {
    var vm = this,dataArrayForFilters=[],locFilter='', catFilter='';

    vm.model = {
      allTrainings: [],
      selectedDate: modalParams.day.date,
      airportList: [],
      locationList :[],
      trainingCategories: [],
      programs:[],
      programDetails:[],
      formVal: {
        selectedLocation: null,
        selectedTrainingCategory: null
      },
      selectedTrainingParam: null,
      allFlags: null,
      isLoadingVisible : true,
      showInCrewPortal:{
        value:false,
        isVisible:false,
        isEnabled:false
      },
      isHideinCrewPortal: false,
      popover:{
        trainingProgram: null,
        trainingProgramDetail:null,
        trainingProgramDetailId:null
      },
      selectedTraining:null,
      addTrainingClicked :false
    };

    (function () {
      getTrainings();
      setAutoEnableHideInCrewPortal3O();
    })();

    function checkAppParamsAndIspublished(appParamsEnabled) {
      var isPublished = CrewingHelper.getIsPublished();
      if(!isPublished){
        var isPublished = crewScheduleService.getIsPublished();
      }
      vm.model.isHideinCrewPortal = appParamsEnabled && !isPublished;
    }

    function setAutoEnableHideInCrewPortal3O() {
      var searchRequest = ApplicationParametersService.getAppParamSearchRequest(vm.model.searchCriteria);
      CommonMasterData.loadAppParamList(searchRequest,function(response) {
            if (!!response.appParamGroupMap && response.appParamGroupMap !== null) {
              var appParam = _.filter(response.appParamGroupMap.GENERAL, function (param) {
                if (param.paramKey === "AUTO_ENABLE_HIDE_IN_CREW_PORTAL" && param.paramValue === "Y") {
                  return true;
                }
                if (param.paramKey === "CARRIER_CODE" && param.paramValue === "3O") {
                  return true;
                }
              });
            }
          checkAppParamsAndIspublished(appParam.length === 2 ? true : false);
          },
          function() {
            console
              .log('Application Parameter list retrieval error');
          });
    }

    vm.onCloseClick = function () {
      $uibModalInstance.close();
    };

    vm.onAddTrainingClick = function () {
      vm.model.addTrainingClicked = true;
      if(vm.model.popover.trainingProgram != null &&
        vm.model.popover.trainingProgramDetail !=null) {
        var selectedTraining = vm.model.selectedTraining;
        selectedTraining.crewProfileId = modalParams.crew.crewDTO.crewProfileId;
        selectedTraining.crewId = modalParams.crew.crewId;
        vm.model.selectedTrainingParam = selectedTraining;
        vm.model.allFlags = CrewingHelper.getAssignTrainingFlags();
        assignTraining(vm.model.selectedTrainingParam, vm.model.allFlags);
      }
    };

    function assignTraining(params, flags) {

      var dutyStartLocation;
      if(params.trainingLocCode.length <= 5) {
        dutyStartLocation = params ? params.trainingLocCode : '';
      } else {
        dutyStartLocation = '';
      }

      var crewProfileId = params ? params.crewProfileId : '';
      var dutyStartDate = params ? params.startDateZulu : '';
      var patternId = 0;

      CrewingHelper.isViolatingDutyStartLocationtwithPreviousLocation(dutyStartLocation,
        crewProfileId, dutyStartDate, patternId, function (updateResponse) {

          if(!updateResponse.baseMatching) {
            var details = {
              title: 'Confirmation',
              messages: [MessageService.MESSAGES.CREWING.PREVIOUS_DUTY_END_BASE_IS_DIFFERENT_FROM_THE_NEXT_DUTY_START_BASE]
            };

            PopupManager.openModal('CONFIRM_DIALOG', details, confirmtoProceed);

            function confirmtoProceed(param) {
              if (param === 'YES') {
                TrainingAssignment(params, flags);
              }
            }
          } else {
            TrainingAssignment(params, flags);
          }

        }, function (msg) {
          MessageService.error(msg);
        });


    }

    function TrainingAssignment(params, flags) {

      CrewingHelper.assignTraining(params, flags, vm.model.showInCrewPortal.value, vm.model.isHideinCrewPortal,
        function (assignTrainingResponse) {
          CrewingHelper.assignTrainingActionList(params, assignTrainingResponse, flags, assignTraining, assignSuccessCallBack);
        },
        function (msg) {
          MessageService.error(msg);
        }
      );

    }

    vm.onSelectLocation = function(){
      dataArrayForFilters = vm.model.allTrainings;
      if(vm.model.formVal.selectedLocation!==undefined){
        locFilter = vm.model.formVal.selectedLocation.location;
      }else{
        locFilter = '';
      }
      setCategoryList();
      //filterDataByCategory();
      vm.model.trainings = getFilteredData();
    };

    function setCategoryList(){
      vm.model.categoryList = [];
      var catList = _.groupBy(vm.model.allTrainings, 'trainingProCategory');
      angular.forEach(catList, function(arr, key){
        vm.model.categoryList.push({
          category:key,
          categoryData:arr
        })
      });
    }

    vm.onSelectCategory = function(){
      if(vm.model.formVal.selectedTrainingCategory!==undefined) {
        catFilter = vm.model.formVal.selectedTrainingCategory.category;
      }else{
        catFilter = '';
      }
      filterDataByCategory();
    };

    function filterDataByCategory(){
      vm.scrollAreaWidth = 0;
      vm.minimumTopPosition = null;
      var temp = getFilteredData();
      vm.filteredData = temp;
      vm.model.trainings = vm.filteredData;

    }

    function getFilteredData(){
      if (locFilter!==''){
        var locList = _.groupBy(vm.model.allTrainings, 'trainingLocCode');
        dataArrayForFilters = locList[locFilter];
      }else{
        dataArrayForFilters = vm.model.allTrainings;
      }
      if (catFilter!==''){
        var catList = _.groupBy(dataArrayForFilters, 'trainingProCategory');
        dataArrayForFilters = catList[catFilter];
      }
      return dataArrayForFilters;
    }

    function scrollToMinimum(){
      $timeout(function (d) {
        angular.element('.training-right-section').animate({ scrollTop: vm.minimumTopPosition }, "fast");
      },500);
    }


    function assignSuccessCallBack() {
      $uibModalInstance.close([vm.model.selectedTrainingParam.crewId]);
    }

    function setLocationList(){
      vm.model.locationList = [];
      var locList = _.groupBy(vm.model.allTrainings, 'trainingLocCode');
      angular.forEach(locList, function(arr, key){
        vm.model.locationList.push({
          location:key,
          locationDate:arr
        })
      });
    }

    vm.onClickTraining = function(training){
      vm.model.selectedTraining = training;

        CommonMasterData.getTrainingProgram(training,
          function (programsResults) {
            vm.model.programs = programsResults;
            setTrainingProgram(training);
          },
          function (error) {
            MessageService.error(MessageService.MESSAGES.COMMON.SYSTEM_ERROR);
          }
        );
    };

    function setTrainingProgram(training){
      vm.model.popover.trainingProgram === null;
      vm.model.popover.trainingProgramDetail === null;
      if(!!training.trainingProgramDesc && training.trainingProgramDesc!== null){
        var prgList = _.filter(vm.model.programs ,function(prog){return training.trainingProgramDesc === prog.trainingProgramCode});
        vm.model.popover.trainingProgram = prgList[0];
        training.trainingProgram = vm.model.popover.trainingProgram;
        vm.onChangeProgram(vm.model.popover.trainingProgram);
      }
    }

    function setTrainingProgramDetail(trainingProgramDetailCode) {
      var prgDetList = _.filter(vm.model.programDetails ,function(prog){return trainingProgramDetailCode === prog.trainingProgDetailCode});
      vm.model.popover.trainingProgramDetail = prgDetList[0];
      vm.model.selectedTraining.trainingProgramDetail = vm.model.popover.trainingProgramDetail;
    }

    vm.onChangeProgram = function(selectedItem){
      vm.model.popover.trainingProgram === null;
      if(!!selectedItem){
        vm.model.popover.trainingProgramId = selectedItem.trainingProgramId;
        CommonMasterData.getTrainingProgramDetails(selectedItem,
          function (programDetailsResults) {
            vm.model.programDetails = programDetailsResults;
            if(!!vm.model.selectedTraining && vm.model.selectedTraining.trainingProgramDetailCode !== null){
              setTrainingProgramDetail(vm.model.selectedTraining.trainingProgramDetailCode);
            }
          },
          function (error) {
            MessageService.error(MessageService.MESSAGES.COMMON.SYSTEM_ERROR);
          }
        );
      }
    };

    vm.onChangeProgramDetail = function(selectedItem){
      if (selectedItem!==undefined){
        vm.model.popover.trainingProgramDetailId = selectedItem.trainingProgramDetailId;
      }
    };


    function getTrainings() {

      vm.model.isLoadingVisible = true;
      if(!angular.isUndefined(modalParams.showInCrewPortalParams)){
        vm.model.showInCrewPortal = modalParams.showInCrewPortalParams;
      }
      CrewingHelper.getTrainings(modalParams.day.date, modalParams.crew.crewDTO.crewProfileId,
        function (searchResults) {
          if(searchResults.length>0){
            vm.model.trainings = searchResults;
            vm.model.allTrainings = searchResults;
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREATE_PAIRING.TRAINING_DATA_CHANGE, vm.model.trainings);
            vm.model.isLoadingVisible = false;
            setLocationList();
            setCategoryList();
          }
          else{
            vm.onCloseClick();
          }
        },
        function (msg) {
          vm.model.isLoadingVisible = false;
          MessageService.error(msg)
        });
    }
  }
}());

//# sourceMappingURL=../../crewing/controllers/assign-training-controller.js.map
